t = require('app/scripts/views/internal/teacup-with-helpers')('board_member_profile')

module.exports = ->
  t.div '.window-header.u-clearfix', ->
    t.span '.window-header-icon.icon-lg.icon-activity'
    t.h2 '.window-title', ->
      if t.mustacheVar('fullName') != t.mustacheVar('username')
        t.text t.mustacheVar('fullName')

        t.span '.quiet', { style: 'margin-left: 3px' }, ->
          t.text "(#{t.mustacheVar('username')})"
      else
        t.span '.quiet', { style: 'margin-left: 3px' }, ->
          t.text "@#{t.mustacheVar('username')}"

  t.div '.window-main-col.window-main-col-full', ->
    t.div '.list-actions', ->
      t.p '.js-board-member-profile-no-activity', ->
        t.format 'this-member-has-no-board-activity'
    t.a '.show-more.js-more-actions', { href: '#' }, ->
      t.format 'load-more-activity'
